(function (window, $) {
  class CheckboxGroup {
    constructor(options) {
      this.options = $.extend(
        {
          data: [], // { value: NumberString; name: string; disabled?: boolean}[]
          value: [], // Array of selected values
          disabled: false,
          container: null,
          labelSlot: null, // Function (item) => string | DOM | jQuery
        },
        options,
      );

      this.emitter = window.useEmitter();
      this.checkboxes = [];
      this.$html = null;
      this.init();
    }

    init() {
      this.$html = $("<div>").addClass("checkbox-group");
      if (this.options.container) {
        $(this.options.container).append(this.$html);
      }
      this.render();
    }

    render() {
      this.$html.empty();
      this.checkboxes = [];

      const { data, value, disabled, labelSlot } = this.options;

      if (!Array.isArray(data)) return;

      data.forEach((item) => {
        const isChecked = value.includes(item.value);
        const isDisabled = disabled || item.disabled;

        let itemLabelSlot = item.labelSlot;
        if (typeof labelSlot === "function") {
          itemLabelSlot = labelSlot(item);
        }

        const checkbox = new window.Checkbox({
          value: item.value,
          label: item.name,
          labelSlot: itemLabelSlot,
          checked: isChecked,
          disabled: isDisabled,
          container: this.$html,
        });

        // Listen to change event
        checkbox.emitter.on("change", (checked, val) => {
          this.handleCheckboxChange(checked, val);
        });

        this.checkboxes.push(checkbox);
      });
    }

    handleCheckboxChange(checked, val) {
      const index = this.options.value.indexOf(val);
      if (checked) {
        if (index === -1) {
          this.options.value.push(val);
        }
      } else {
        if (index !== -1) {
          this.options.value.splice(index, 1);
        }
      }
      this.emitter.emit("change", this.options.value);
    }

    getValue() {
      return this.options.value;
    }

    setValue(values) {
      if (!Array.isArray(values)) return;
      this.options.value = [...values];

      this.checkboxes.forEach((checkbox) => {
        const val = checkbox.options.value;
        const shouldCheck = values.includes(val);
        checkbox.setValue(shouldCheck);
      });
    }

    setDisabled(disabled) {
      this.options.disabled = disabled;
      this.checkboxes.forEach((checkbox) => {
        if (disabled) {
          checkbox.setDisabled(true);
        } else {
          const item = this.options.data.find((d) => d.value === checkbox.options.value);
          if (item && item.disabled) {
            checkbox.setDisabled(true);
          } else {
            checkbox.setDisabled(false);
          }
        }
      });
    }

    updateData(data) {
      if (data) {
        this.options.data = data;
      }
      this.render();
    }
  }

  window.CheckboxGroup = CheckboxGroup;
})(window, jQuery);
